import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavItem from "./NavItem";
import { menuList } from "../menuList";
import { Drawer, Typography, useTheme } from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import GoogleIcon from "@mui/icons-material/Google";
import CallIcon from "@mui/icons-material/Call";

const SidebarNav = ({ onClose, open, variant }) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      open={open}
      variant={variant}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: 280,
          backgroundColor: theme.palette.background,
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          padding: 1,
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
            width={1}
            paddingX={2}
            paddingY={1}
          >
            <Typography component="a" sx={{ mr: 0.5 }} href={"/"}>
              <img src="/logo.png" alt="logo" width={150} />
            </Typography>
          </Box>
          <Box paddingX={2} paddingY={2}>
            {menuList.map((page) =>
              page.items ? (
                <Box sx={{ ml: 1, fontSize: 15 }}>
                  <NavItem title={page.name} items={page.items} />
                </Box>
              ) : (
                <Button
                  component="a"
                  href={page.href}
                  sx={{
                    display: "block",
                    color: "white",
                    fontSize: 17,
                    "&:hover": {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  {page.name}
                </Button>
              )
            )}

            <Box sx={{ my: 2 }}>
              <Typography fontSize={13} color={"primary"} sx={{ my: 1 }}>
                {" "}
                Téléchargez l'appli disponible
              </Typography>
              <Button
                sx={{ color: "white" }}
                fullWidth
                variant="outlined"
                startIcon={<AppleIcon />}
                href="https://bit.ly/45qf53R"
              >
                sur AppStore
              </Button>
              <Button
                fullWidth
                sx={{ my: 1, color: "white" }}
                variant="outlined"
                startIcon={<GoogleIcon />}
                href="https://bit.ly/3orAlFE"
              >
                sur Google Play
              </Button>
            </Box>
            <Box>
              <Typography fontSize={13} color={"primary"} sx={{ my: 1 }}>
                Pour plus d'infos, appelez au
              </Typography>
              <Button fullWidth variant="outlined" startIcon={<CallIcon />}>
                +243 827 724 555
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

SidebarNav.propTypes = {
  pages: PropTypes.object.isRequired,
};

export default SidebarNav;
